module.exports = __webpack_public_path__ + "img/img2e.850027db.png";